import { useApi } from "@lending/lib/api";

interface Options {
  enabled?: boolean;
}

function useGetApplicationApplicantDetailsSensitiveQuery(
  uuid: string,
  { enabled }: Options = { enabled: true }
) {
  const $api = useApi();

  return $api.useQuery(
    "get",
    "/v2/lending/application_applicant_details/{uuid}/sensitive/",
    {
      params: {
        path: {
          uuid,
        },
      },
    },
    { enabled: Boolean(uuid) && enabled }
  );
}

export { useGetApplicationApplicantDetailsSensitiveQuery };
